import {
  Box,
  Hide,
  HStack,
  Text,
  ThemeColorPath,
  ThemeColorTextPath,
  VStack,
} from 'platform/foundation';
import {match, Pattern} from 'ts-pattern';

import {suffixTestId, TestIdProps} from 'shared/web';

interface ListTextProps extends TestIdProps {
  isRow?: boolean;
  value: string;
  showDot: boolean;
  textColor: ThemeColorTextPath;
  showBackground: boolean;
  isMyVehicle?: boolean;
  isMyAd?: boolean;
  isMissing?: boolean;
  isBold?: boolean;
}

export function ListText(props: ListTextProps) {
  const backgroundColor = match<[boolean, boolean, boolean], ThemeColorPath | undefined>([
    !props.isRow && props.showBackground,
    !!props.isMyVehicle,
    !!props.isMyAd,
  ])
    .with([true, true, Pattern.any], () => 'palettes.teal.30.100')
    .with([true, false, true], () => 'palettes.green.20.100')
    .with([true, false, false], () => 'palettes.neutral.10.100')
    .with([false, Pattern.any, Pattern.any], () => undefined)
    .exhaustive();

  return (
    <>
      <Box
        maxWidth="100%"
        paddingVertical={[0, props.isRow ? 0 : 1]}
        paddingHorizontal={[0, props.isRow ? 0 : 2]}
        backgroundColor={[undefined, backgroundColor]}
        overflow="hidden"
      >
        <VStack width="100%" minHeight={[undefined, props.isRow ? undefined : 5]} justify="center">
          <Text
            color={props.isMissing ? 'danger' : props.textColor}
            size="xSmall"
            alternative={!props.isMissing && props.isBold}
            noWrap
            title={props.value}
            data-testid={suffixTestId('text', props)}
          >
            {props.value}
          </Text>
        </VStack>
      </Box>
      <Hide onTablet onNotebook onDesktop inPrinter when={!props.isRow || !props.showDot}>
        <HStack align="center">
          <Text
            color={props.textColor}
            size={['xSmall', props.isRow ? 'xSmall' : 'small']}
            data-testid={suffixTestId('dot', props)}
          >
            •
          </Text>
        </HStack>
      </Hide>
    </>
  );
}
